import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import { useProfileContext } from "provider/ProfileProvider";
import { useToast } from "provider/ToastProvider";
import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
const GeneralInfo = ({ genInfoSubmit }) => {
   
    const { userAccData, genInfoForm, genInfoLoading, genInfoErrors, profileDispatch } = useProfileContext();
    




    useEffect(() => {
        if (userAccData) {
            profileDispatch({
                type: "SET_GEN_INFO_FORM",
                payload: {
                    name: userAccData.name || "",
                    mobile_no: userAccData.mobile_no || "",
                    date_of_birth: userAccData.date_of_birth || "",
                    user_handle: userAccData.user_handle || "",
                    gender: userAccData.gender || 0,
                    user_bio: userAccData.user_bio || "",
                    about: userAccData.about || "",
                    facebook_url: userAccData.facebook_url || "",
                    x_url: userAccData.x_url || "",
                    insta_url: userAccData.insta_url || "",
                    youtube_url: userAccData.youtube_url || "",
                    // website_url: userAccData.website_url || "",
                },
            });

        }
    }, [userAccData]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        profileDispatch({
            type: "SET_GEN_INFO_FORM",
            payload: { [name]: value },
        });

        profileDispatch({
            type: "SET_GEN_INFO_ERRORS",
            payload: { [name]: '' }, // clear error on change
        });
    };



    return (
        <Form onSubmit={genInfoSubmit}>
            <Row>
                <Col md={6}>
                    <div className="mb-3">
                        <Form.Label htmlFor="name">Name</Form.Label>
                        <Form.Control
                            id="name"
                            name="name"
                            value={genInfoForm.name}
                            onChange={handleChange}
                            placeholder="Enter Name"
                            isInvalid={!!genInfoErrors.name}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors.name}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <Form.Label htmlFor="mobile_no">Mobile Number</Form.Label>
                        <Form.Control
                            id="mobile_no"
                            name="mobile_no"
                            value={genInfoForm.mobile_no}
                            onChange={handleChange}
                            placeholder="Mobile Number"
                            isInvalid={!!genInfoErrors.mobile_no}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors.mobile_no}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={6} className="typeaccount">
                    Account Type <br />
                    <b>Traveller</b>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <Form.Label htmlFor="user_handle">Username</Form.Label>
                        <Form.Control
                            id="user_handle"
                            name="user_handle"
                            value={genInfoForm.user_handle}
                            onChange={handleChange}
                            placeholder="User Name"
                            isInvalid={!!genInfoErrors.user_handle}
                        />
                        <div className="form-text text-muted">
                            <i>Allowed Character: az09_-</i>
                        </div>
                        <Form.Control.Feedback type="invalid">{genInfoErrors.user_handle}</Form.Control.Feedback>
                    </div>
                </Col>

                <Col md={6}>
                    <div className="mb-3">
                        <Form.Label htmlFor="date_of_birth">D.O.B.</Form.Label>
                        <Form.Control
                            type="date"
                            id="date_of_birth"
                            name="date_of_birth"
                            value={genInfoForm.date_of_birth}
                            onChange={handleChange}
                            isInvalid={!!genInfoErrors.date_of_birth}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors.date_of_birth}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="mb-3">
                        <Form.Label htmlFor="gender">Gender</Form.Label>
                        <Form.Select
                            id="gender"
                            name="gender"
                            value={genInfoForm.gender}
                            onChange={handleChange}
                            isInvalid={!!genInfoErrors.gender}
                        >
                            <option value="">Select Gender</option>
                            <option value={1}>Male</option>
                            <option value={2}>Female</option>
                            <option value={3}>Others</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">{genInfoErrors.gender}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor="user_bio">You are</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            id="user_bio"
                            name="user_bio"
                            value={genInfoForm.user_bio}
                            onChange={handleChange}
                            placeholder="Profile Description eg: Wildlife | Nature"
                            isInvalid={!!genInfoErrors.user_bio}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors.user_bio}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor="about">About</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={6}
                            id="about"
                            name="about"
                            value={genInfoForm.about}
                            onChange={handleChange}
                            placeholder="About"
                            isInvalid={!!genInfoErrors.about}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors.about}</Form.Control.Feedback>
                    </div>
                </Col>
                {/* {["facebook_url", "x_url", "insta_url", "youtube_url", "website_url"].map((field) => (
                    <Col md={12} key={field}>
                        <div className="mb-3">
                            <Form.Label htmlFor={field}>
                                {field.replace("_url", "").replace("x", "Twitter").replace("_", " ").toUpperCase()}
                            </Form.Label>
                            <Form.Control
                                id={field}
                                name={field}
                                value={genInfoForm[field]}
                                onChange={handleChange}
                                placeholder={`${field.replace("_url", "").replace("x", "X")} Link`}
                                isInvalid={!!genInfoErrors[field]}
                            />
                            <Form.Control.Feedback type="invalid">{genInfoErrors[field]}</Form.Control.Feedback>
                        </div>
                    </Col>
                ))} */}
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor='facebook_url'>
                            Facebook
                        </Form.Label>
                        <Form.Control
                            id={'facebook_url'}
                            name={'facebook_url'}
                            value={genInfoForm?.facebook_url}
                            onChange={handleChange}
                            placeholder={`Facebook Link`}
                            isInvalid={!!genInfoErrors?.facebook_url}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors?.facebook_url}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor='x_url'>
                            Twitter Link
                        </Form.Label>
                        <Form.Control
                            id={'x_url'}
                            name={'x_url'}
                            value={genInfoForm?.x_url}
                            onChange={handleChange}
                            placeholder={`X Link`}
                            isInvalid={!!genInfoErrors?.x_url}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors?.x_url}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor='insta_url'>
                            Instagram
                        </Form.Label>
                        <Form.Control
                            id={'insta_url'}
                            name={'insta_url'}
                            value={genInfoForm?.insta_url}
                            onChange={handleChange}
                            placeholder={`Instagram Link`}
                            isInvalid={!!genInfoErrors?.insta_url}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors?.insta_url}</Form.Control.Feedback>
                    </div>
                </Col>
                <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor='youtube_url'>
                            Youtube Url
                        </Form.Label>
                        <Form.Control
                            id={'youtube_url'}
                            name={'youtube_url'}
                            value={genInfoForm?.youtube_url}
                            onChange={handleChange}
                            placeholder={`Youtube Link`}
                            isInvalid={!!genInfoErrors?.youtube_url}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors?.youtube_url}</Form.Control.Feedback>
                    </div>
                </Col>
                {/* <Col md={12}>
                    <div className="mb-3">
                        <Form.Label htmlFor='website_url'>
                            Website Url
                        </Form.Label>
                        <Form.Control
                            id={'website_url'}
                            name={'website_url'}
                            value={genInfoForm?.website_url}
                            onChange={handleChange}
                            placeholder={`Youtube Link`}
                            isInvalid={!!genInfoErrors?.website_url}
                        />
                        <Form.Control.Feedback type="invalid">{genInfoErrors?.website_url}</Form.Control.Feedback>
                    </div>
                </Col> */}

                <Col md={12}>
                    <div className="float-start">
                        {/* <button type="button" className="post-comment" onClick={deactivateAccount} disabled={loading} >
                            Deactivate Account
                        </button> */}
                    
                    </div>
                    <div className="float-end">
                        <button type="submit" className="post-comment" disabled={genInfoLoading}>
                            Save Change
                        </button>
                    </div>
                </Col>
            </Row>
        </Form>
    )
}

export default GeneralInfo